// import React from "react";
// import { Grid, Paper, Typography, Box } from "@mui/material";

// export default function OverviewCards({ stats }) {
//   const cards = [
//     { label: "Job Orders", value: stats.jobOrders, color: "#6c63ff" },
//     { label: "Applications", value: stats.applications, color: "#00bfae" },
//     { label: "Hires", value: stats.hires, color: "#43a047" },
//     { label: "Interviews", value: stats.interviews, color: "#ff9800" },
//     { label: "New Candidates", value: stats.newCandidates, color: "#e040fb" },
//   ];

//   return (
//     <Grid container spacing={2} mb={3}>
//       {cards.map((card) => (
//         <Grid item xs={12} sm={6} md={2.4} key={card.label}>
//           <Paper
//             elevation={0}
//             sx={{
//               p: 2.25,
//               borderRadius: 2,
//               position: "relative",
//               bgcolor: "#ffffff",
//               border: "1px solid",
//               borderColor: "divider",
//               borderLeftWidth: 6,
//               borderLeftColor: card.color,
//               boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "space-between",
//               minHeight: 96,
//               transition:
//                 "transform 0.18s ease-out, box-shadow 0.18s ease-out",
//               "&:hover": {
//                 transform: "translateY(-3px)",
//                 boxShadow: "0 14px 32px rgba(15,23,42,0.18)",
//               },
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="overline"
//                 sx={{
//                   fontSize: 11,
//                   letterSpacing: 0.8,
//                   textTransform: "uppercase",
//                   color: "text.secondary",
//                 }}
//               >
//                 {card.label}
//               </Typography>
//               <Typography
//                 variant="h5"
//                 sx={{
//                   mt: 0.5,
//                   fontWeight: 700,
//                   color: card.color,
//                   lineHeight: 1.1,
//                 }}
//               >
//                 {card.value}
//               </Typography>
//             </Box>
//           </Paper>
//         </Grid>
//       ))}
//     </Grid>
//   );
// }

import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function OverviewCards({ stats }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const cards = [
    { label: "Job Orders", value: stats.jobOrders, color: dark ? "#fb923c" : "#f97316" },
    { label: "Applications", value: stats.applications, color: "#06b6d4" },
    { label: "Hires", value: stats.hires, color: "#22c55e" },
    { label: "Interviews", value: stats.interviews, color: "#f59e0b" },
    { label: "New Candidates", value: stats.newCandidates, color: "#a855f7" },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={2.4} key={card.label}>
          <Paper
            elevation={0}
            sx={{
              p: 2.4,
              borderRadius: "22px",
              background: dark
                ? "rgba(13,18,32,0.96)"
                : "rgba(255,255,255,0.98)",
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: 112,
              transition:
                "transform 0.18s ease-out, box-shadow 0.18s ease-out, border-color 0.18s ease-out",
              "&:hover": {
                transform: "translateY(-3px)",
                borderColor: alpha(card.color, 0.28),
                boxShadow: dark
                  ? "0 24px 56px rgba(0,0,0,0.26)"
                  : "0 18px 38px rgba(15,23,42,0.10)",
              },
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 4,
                borderRadius: 999,
                bgcolor: card.color,
                mb: 1.6,
              }}
            />

            <Box>
              <Typography
                sx={{
                  fontSize: 11,
                  letterSpacing: "0.16em",
                  textTransform: "uppercase",
                  color: mid,
                  fontWeight: 500,
                  fontFamily:
                    '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
                }}
              >
                {card.label}
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  fontWeight: 800,
                  color: text,
                  lineHeight: 1.05,
                  fontSize: { xs: "1.8rem", md: "2rem" },
                  letterSpacing: "-0.03em",
                }}
              >
                {card.value ?? 0}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}